import { isHasValue } from '../Utils/Helpers';
import { validateEmail, validateNRIC, validatePostcode } from './rules'; // or "../Validators/rules" based on location

export function validateInvoiceForm({
  id,
  idType,
  taxNo,
  name,
  email,
  phoneNumber,
  address1,
  postcode,
  city,
  state,
  country,
  invNo,
  setErrorFns,
}) {
  let isValid = true;
  const {
    setErrId,
    setErrTaxNo,
    setErrName,
    setErrEmail,
    setErrPhone,
    setErrAddress1,
    setErrPostcode,
    setErrCity,
    setErrState,
    setErrCountry,
    setErrInvNo,
  } = setErrorFns;

  if (!isHasValue(id)) {
    setErrId('This field is required');
    isValid = false;
  }
  if (idType?.value === 'NRIC' && !validateNRIC(id)) {
    setErrId('Invalid NRIC');
    isValid = false;
  }
  if (!isHasValue(taxNo)) {
    setErrTaxNo('This field is required');
    isValid = false;
  }
  if (!isHasValue(name)) {
    setErrName('This field is required');
    isValid = false;
  }
  if (!isHasValue(email)) {
    setErrEmail('This field is required');
    isValid = false;
  } else if (!validateEmail(email)) {
    setErrEmail('Invalid email');
    isValid = false;
  }
  if (!isHasValue(phoneNumber)) {
    setErrPhone('This field is required');
    isValid = false;
  }
  if (!isHasValue(address1)) {
    setErrAddress1('This field is required');
    isValid = false;
  }
  if (!isHasValue(postcode)) {
    setErrPostcode('This field is required');
    isValid = false;
  } else if (!validatePostcode(postcode)) {
    setErrPostcode('Invalid postcode');
    isValid = false;
  }
  if (!isHasValue(city)) {
    setErrCity('This field is required');
    isValid = false;
  }
  if (!isHasValue(state.value)) {
    setErrState('This field is required');
    isValid = false;
  }
  if (!isHasValue(country.value)) {
    setErrCountry('This field is required');
    isValid = false;
  }
  if (!isHasValue(invNo)) {
    setErrInvNo('This field is required');
    isValid = false;
  }

  return isValid;
}
